import CountPill from "@/components/count-pill"
import { useFetchMissedInboundCallCounts } from "@/pages/MissedInboundCalls/missed-calls-api"

const MissedInboundCallsCountPill = () => {
  const { data, isLoading } = useFetchMissedInboundCallCounts()
  const missedInboundCallsCount = data?.data.total

  return <CountPill value={missedInboundCallsCount} isLoading={isLoading} />
}

export default MissedInboundCallsCountPill
